import { render, staticRenderFns } from "./FormDraggable.vue?vue&type=template&id=f9bd23e4&scoped=true&"
import script from "./FormDraggable.vue?vue&type=script&lang=js&"
export * from "./FormDraggable.vue?vue&type=script&lang=js&"
import style0 from "./FormDraggable.vue?vue&type=style&index=0&id=f9bd23e4&lang=scss&scoped=true&"
import style1 from "./FormDraggable.vue?vue&type=style&index=1&id=f9bd23e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bd23e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9bd23e4')) {
      api.createRecord('f9bd23e4', component.options)
    } else {
      api.reload('f9bd23e4', component.options)
    }
    module.hot.accept("./FormDraggable.vue?vue&type=template&id=f9bd23e4&scoped=true&", function () {
      api.rerender('f9bd23e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormDraggable.vue"
export default component.exports